const textAlign = {
  name: "text-align",
  path: "/text-align",
  title: "text-align",
  description: "Utilities for controlling the alignment of text.",
  value: {
    "text-align": {
      "text-left": "left",
      "text-center": "center",
      "text-right": "right",
      "text-justify": "justify",
      "text-start": "start",
      "text-end": "end"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="text-left">Left aligned text</p>
<p class="text-center">Center aligned text</p>
<p class="text-right">Right aligned text</p>
<p class="text-justify">Justified text</p>
<p class="text-start">Start aligned text (LTR/RTL aware)</p>
<p class="text-end">End aligned text (LTR/RTL aware)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">text-left</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">text-center</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">text-right</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">text-justify</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">text-start</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">text-end</code> to control text alignment.
      </p>
      <div class="*:py-5 divide-y divide-color-gray-200 dark:divide-color-gray-700">
        <div class="!pt-0">
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-left</small>
          <p class="text-sm text-left">So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-center</small>
          <p class="text-sm text-center">So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-right</small>
          <p class="text-sm text-right">So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-justify</small>
          <p class="text-sm text-justify">So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-start</small>
          <p class="text-sm text-start">So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">text-end</small>
          <p class="text-sm text-end">So I started to walk into the water. I won't lie to you boys, I was terrified. But I pressed on, and as I made my way past the breakers a strange calm came over me. I don't know if it was divine intervention or the kinship of all living things but I tell you Jerry at that moment, I was a marine biologist.</p>
        </div>
      </div>
      `
    }
  ]
}
export default textAlign;
<div className="text-left !pt-0 *:py-5 text-center text-right text-justify text-start text-end divide-y divide-color-gray-200 dark:divide-color-gray-700"></div>